import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAppDispatch } from "../../store/hooks";
import { registerThunk } from "../../store/features/auth/authSlice";
import classes from "./styles.module.scss";
import { InputField } from '../../components/InputField';
import { MainButton } from '../../components/MainButton';
import { showNotification } from "../../store/features/notifications/notificationSlice";

export const RegisterPage = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(registerThunk({ email, password }))
      .unwrap()
      .then(() => {
        navigate("/signIn");
        dispatch(showNotification({ message: "Account created sccesfully.", type: "success" }));
      })
      .catch(() => {
        dispatch(showNotification({ message: "Failed to create your account.", type: "error" }));
      });
  };

  return (
    <div className={classes.RegisterPage}>
      <div className={classes.contentWrapper}>
        <div className={classes.logo} onClick={() => navigate("/")} >.shortform</div>
        <div className={classes.infoWrapper}>
          <h2>Register for an account</h2>
          <div className={classes.infoText}>
            <p>Already registered? <a href="" onClick={() => navigate("/signIn")}>Sign in</a> to your account now.</p>
          </div>
        </div>
        <div className={classes.breakLine}>
          <div className={classes.midLine}></div>
          <span>or</span>
          <div className={classes.midLine}></div>
        </div>
        <div className={classes.formWrapper}>
          {/* <InputField label='First Name' />
          <InputField label='Last Name' /> */}
          <InputField label='Email' role='email' value={email} onChange={(e) => setEmail(e.target.value)} onValidationError={setEmailError} />
          <InputField label='Password' type="password" role='password' value={password} onChange={(e) => setPassword(e.target.value)} onValidationError={setPasswordError} />
          <MainButton title='Create an account' variant='primary' fullWidth onClick={handleSubmit} disabled={!email || !password || !!emailError || !!passwordError} />
        </div>
      </div>
    </div>
  )
}

export default RegisterPage